import * as React from 'react';

import PropTypes from 'prop-types';

import {QuotaRow} from '../quota-row';
import {QuotasEmptyState} from '../quotas-empty-state';

export class Quotas extends React.Component {
    static propTypes = {
        dashboardQuotas: PropTypes.array.isRequired,
        loggedInUser: PropTypes.object,
    };

    render() {
        return <div>{renderQuotaGauges(this.props.dashboardQuotas, this.props.loggedInUser)}</div>;
    }
}

/**
 * Render quota gauges for each quota this dash contains. Also uses a loggedInUser
 * for setup purposes (i.e. non-admins should not see "Setup this quota" links)
 * @param  {Array} quotas       Array of quotas
 * @param  {object} loggedInUser Logged in user model
 * @return {Array}              Array of quota row components
 */
export function renderQuotaGauges(quotas, loggedInUser) {
    if (!quotas || quotas.length === 0) return <QuotasEmptyState />;
    if (quotas && quotas.length === 1) return <QuotaRow {...quotas[0]} type='fuel' />;

    return quotas.map((quota, index) => {
        return (
            <QuotaRow
                {...quota}
                loggedInUser={loggedInUser}
                key={`${quota.name}-${quota.assignee.name}`}
                index={index}
                type='bar'
            />
        );
    });
}
